import { useState } from "react";
import { X, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

export default function AnnouncementBar() {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  return (
    <div
      className="relative flex items-center justify-center gap-3 px-4 py-2 text-center"
      style={{
        background: "linear-gradient(90deg, rgba(0,212,255,0.12) 0%, rgba(123,47,190,0.12) 100%)",
        borderBottom: "1px solid rgba(0,212,255,0.15)",
      }}
      data-testid="announcement-bar"
    >
      <div className="flex items-center gap-2 text-xs" style={{ fontFamily: "var(--font-mono)", color: "var(--text-muted)" }}>
        <span className="w-1.5 h-1.5 rounded-full bg-[#00D4FF] animate-pulse flex-shrink-0" />
        <span>
          <span className="text-white font-medium">June 2027</span>
          <span className="hidden sm:inline"> · Niagara Falls, Ontario · Exact dates & venue to be announced</span>
        </span>
      </div>
      <Link
        to="/attend"
        className="hidden sm:inline-flex items-center gap-1 text-xs font-medium transition-colors"
        style={{ color: "var(--cyan)", fontFamily: "var(--font-mono)" }}
        data-testid="announcement-cta"
      >
        Join Priority List <ArrowRight size={11} />
      </Link>
      <button
        onClick={() => setDismissed(true)}
        className="absolute right-3 top-1/2 -translate-y-1/2 p-1 hover:text-white transition-colors"
        style={{ color: "var(--text-muted)" }}
        aria-label="Dismiss announcement"
        data-testid="announcement-dismiss"
      >
        <X size={13} />
      </button>
    </div>
  );
}
